import { notifications } from '@mantine/notifications'
import { normalizeErrorString } from '@medplum/core'
import { useMedplum } from '@medplum/react'
import { useQuery } from '@tanstack/react-query'
import { IconAlertCircle } from '@tabler/icons-react'

export const organizationQueryKey = (organizationId: string | undefined) =>
  ['medplum-organization', { organizationId }] as const

export function useOrganization(organizationId: string | undefined) {
  const medplum = useMedplum()

  return useQuery({
    enabled: !!organizationId,
    queryKey: organizationQueryKey(organizationId),
    queryFn: async () => {
      try {
        return await medplum.readResource('Organization', organizationId!)
      } catch (error) {
        notifications.show({
          icon: <IconAlertCircle />,
          color: 'red',
          title: 'Error',
          message: `Failed to load organization: ${normalizeErrorString(error)}`,
        })
        throw error
      }
    },
  })
}
